module.exports = __webpack_public_path__ + "static/media/baseImg.17389783.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseImg.png
// module id = 2023
// module chunks = 0